import { isEmpty, toastSuccess } from "../../../utils/helpers/helper";

import {
  CREATE_PAGE_VIEW_FAILURE,
  CREATE_PAGE_VIEW_START,
  CREATE_PAGE_VIEW_SUCCESS,
  FETCH_PAGE_FAVORITE_FAILURE,
  FETCH_PAGE_FAVORITE_START,
  FETCH_PAGE_FAVORITE_SUCCESS,
  FETCH_PAGE_FAVORITES_FAILURE,
  FETCH_PAGE_FAVORITES_START,
  FETCH_PAGE_FAVORITES_SUCCESS,
  FETCH_PAGE_VIEW_FAILURE,
  FETCH_PAGE_VIEW_START,
  FETCH_PAGE_VIEW_SUCCESS,
  MANAGE_USER_BILLING_FAIL,
  MANAGE_USER_BILLING_REQUEST,
  MANAGE_USER_BILLING_SUCCESS,
  EMAIL_BODY_FAIL,
  EMAIL_BODY_REQUEST,
  EMAIL_BODY_SUCCESS,
  USER_DETAILS_FAIL,
  USER_DETAILS_REQUEST,
  USER_DETAILS_SUCCESS,
  USER_EDITABLE_TEMPLATES_FAIL,
  USER_EDITABLE_TEMPLATES_REQUEST,
  USER_EDITABLE_TEMPLATES_SUCCESS,
  USER_LIFETIME_OFFER_FAIL,
  USER_LIFETIME_OFFER_REQUEST,
  USER_LIFETIME_OFFER_SUCCESS,
  USER_SET_FREE_MODE_FAIL,
  USER_SET_FREE_MODE_REQUEST,
  USER_SET_FREE_MODE_SQFT_FAIL,
  USER_SET_FREE_MODE_SQFT_REQUEST,
  USER_SET_FREE_MODE_SQFT_SUCCESS,
  USER_SET_FREE_MODE_SUCCESS,
  USER_UPDATE_FAIL,
  USER_UPDATE_REQUEST,
  USER_UPDATE_SUCCESS,
  USER_TRADE_UPDATE_REQUEST,
  USER_TRADE_UPDATE_SUCCESS,
  USER_TRADE_UPDATE_FAIL,
} from "../../constants/userConstants";
import {
  getUserAPI,
  manageUserBillingAPI,
  setFreeModeAPI,
  setFreeModeSqftAPI,
  updateLifetimeOfferAPI,
} from "../../../utils/requests/users";
import { getUserEditableTemplatesAPI, saveUserEmailTemplateOrderAPI } from "../../../utils/requests/userEmailTemplates";
import axios from "axios";
import {
  DOMAIN_VERIFICATION_FAIL,
  DOMAIN_VERIFICATION_REQUEST,
  DOMAIN_VERIFICATION_SUCCESS,
  SITE_ROUTE_NOTES_SUCCESS,
  UPDATE_SITE_ROUTE_PROJECT_SUCCESS,
} from "../../actionTypes";
import {
  ONBOARDING_FAILURE,
  ONBOARDING_SUCCESS,
  SUBMIT_ONBOARDING_STEP,
} from "../../constants/onboardingConstants";
import { UPDATE_USER_DASHBOARD } from "../../constants/dashboardConstants";

export const getUserDetail = (query = "") => {
  return async (dispatch) => {
    dispatch({
      type: USER_DETAILS_REQUEST,
    });
    return getUserAPI(query)
      .then(async (response) => {
        dispatch({
          type: USER_DETAILS_SUCCESS,
          payload: response,
        });
        dispatch({
          type: USER_SET_FREE_MODE_SUCCESS,
          payload: response.free_mode_action,
        });
        dispatch({
          type: USER_SET_FREE_MODE_SQFT_SUCCESS,
          payload: response.free_sqft_changes,
        });
        dispatch({
          type: UPDATE_SITE_ROUTE_PROJECT_SUCCESS,
          payload: response,
        })
        dispatch({
          type: SITE_ROUTE_NOTES_SUCCESS,
          notes: response.project_site_routes_notes,
        })
        if (response.dashboard_sequence)
          dispatch({
            type: UPDATE_USER_DASHBOARD,
            dashboard: response.dashboard_sequence
          })
        dispatch(fetchUserEditableTemplates());
      })
      .catch((error) => {
        dispatch({
          type: USER_DETAILS_FAIL,
          payload: "Failed to fetch Company information",
        });
      });
  };
};

export const fetchUserEditableTemplates = () => {
  return async (dispatch) => {
    dispatch({ type: USER_EDITABLE_TEMPLATES_REQUEST });
    return getUserEditableTemplatesAPI()
      .then((res) => {
        dispatch({
          type: USER_EDITABLE_TEMPLATES_SUCCESS,
          payload: res || [],
        });
      })
      .catch(() => {
        dispatch({ type: USER_EDITABLE_TEMPLATES_FAIL });
      });
  };
};

export const saveUserEmailTemplateOrder = (order) => {
  return async (dispatch) => {
    return saveUserEmailTemplateOrderAPI(order)
      .then((res) => {
        dispatch({
          type: USER_EDITABLE_TEMPLATES_SUCCESS,
          payload: res || [],
        });
        return res;
      });
  };
};

export const updateUserProfile = (formData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_UPDATE_REQUEST,
    });

    let { access } = getState();
    if (isEmpty(access)) {
      access = JSON.parse(localStorage.getItem("token"));
    }

    const config = {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: `Bearer ${access}`,
      },
    };

    const { data } = await axios.put(
      `${process.env.REACT_APP_BASE_URL}/api/v1/users/profile`,
      formData,
      config
    );

    dispatch({
      type: USER_UPDATE_SUCCESS,
      payload: data,
    });

    localStorage.setItem("user", JSON.stringify(data));
  } catch (error) {
    const message =
      error.response && error.response.data
        ? error.response.data
        : error.message;
    if (message === "Not authorized, token failed") {
      // dispatch(logout())
    }

    dispatch({
      type: USER_UPDATE_FAIL,
      payload: message,
    });
  }
};

export const updateUserTrade = (trade) => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_TRADE_UPDATE_REQUEST,
    });

    let { access } = getState();
    if (isEmpty(access)) {
      access = JSON.parse(localStorage.getItem("token"));
    }

    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    };

    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/users/trade`,
      { trade },
      config
    );

    dispatch({
      type: USER_TRADE_UPDATE_SUCCESS,
      payload: data,
    });

    // Update the user in localStorage with the new trade
    const currentUser = JSON.parse(localStorage.getItem("user"));
    if (currentUser) {
      currentUser.trade = trade;
      localStorage.setItem("user", JSON.stringify(currentUser));
    }

    return data;
  } catch (error) {
    const message =
      error.response && error.response.data
        ? error.response.data
        : error.message;
    if (message === "Not authorized, token failed") {
      // dispatch(logout())
    }

    dispatch({
      type: USER_TRADE_UPDATE_FAIL,
      payload: message,
    });
    throw error;
  }
};

export const setFreeModeAction = () => {
  return async (dispatch) => {
    dispatch({
      type: USER_SET_FREE_MODE_REQUEST,
    });
    return setFreeModeAPI()
      .then(async (response) => {
        dispatch({
          type: USER_SET_FREE_MODE_SUCCESS,
          payload: response.free_mode_count,
        });
      })
      .catch((error) => {
        dispatch({
          type: USER_SET_FREE_MODE_FAIL,
          payload: error,
        });
      });
  };
};

export const updateLifetimeOffer = () => {
  return async (dispatch) => {
    dispatch({
      type: USER_LIFETIME_OFFER_REQUEST,
    });
    return updateLifetimeOfferAPI()
      .then(async (response) => {
        dispatch({
          type: USER_LIFETIME_OFFER_SUCCESS,
        });
      })
      .catch((error) => {
        dispatch({
          type: USER_LIFETIME_OFFER_FAIL,
          payload: error,
        });
      });
  };
};

export const setFreeModeSqFt = () => {
  return async (dispatch) => {
    dispatch({
      type: USER_SET_FREE_MODE_SQFT_REQUEST,
    });
    return setFreeModeSqftAPI()
      .then(async (response) => {
        dispatch({
          type: USER_SET_FREE_MODE_SQFT_SUCCESS,
          payload: response.free_mode_count,
        });
      })
      .catch((error) => {
        dispatch({
          type: USER_SET_FREE_MODE_SQFT_FAIL,
          payload: error,
        });
      });
  };
};

export const getManageUserBilling = (customer_id, payout_portal=false) => {
  return async (dispatch) => {
    dispatch({
      type: MANAGE_USER_BILLING_REQUEST,
    });
    return manageUserBillingAPI(customer_id)
      .then(async (response) => {
        dispatch({
          type: MANAGE_USER_BILLING_SUCCESS,
          payload: response,
        });
        if (payout_portal)
          document.location.href = response.payout_portal_url;
        else
          document.location.href = response.session_url;
      })
      .catch((error) => {
        dispatch({
          type: MANAGE_USER_BILLING_FAIL,
          payload: error,
        });
      });
  };
};

export const sendDomainVerification = (email) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DOMAIN_VERIFICATION_REQUEST,
    });
    let { access } = getState();

    if (isEmpty(access)) {
      access = JSON.parse(localStorage.getItem("token"));
    }

    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    };
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/v1/emails/domain-verification`,
      { email },
      config
    );

    // const result = Object.values(
    //   data.reduce((acc, obj) => ({ ...acc, [obj.id]: obj }), {})
    // );
    toastSuccess("Email Successfully");
    dispatch({
      type: DOMAIN_VERIFICATION_SUCCESS,
      payload: data,
    });
  } catch (error) {
    toastSuccess("There was a problem sending email");
    dispatch({
      type: DOMAIN_VERIFICATION_FAIL,
      payload: error,
    });
  }
};

export const submitOnboardingStep =
  (onBoardingData) => async (dispatch, getState) => {
    try {
      dispatch({ type: SUBMIT_ONBOARDING_STEP });
      let { access } = getState();

      if (isEmpty(access)) {
        access = JSON.parse(localStorage.getItem("token"));
      }

      const config = {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${access}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/users/onboarding`,
        onBoardingData,
        config
      );

      toastSuccess("Thank you");
      dispatch({
        type: ONBOARDING_SUCCESS,
        payload: data,
      });
    } catch (error) {
      toastSuccess("There was a problem sending email");
      dispatch({
        type: ONBOARDING_FAILURE,
        payload: error,
      });
    }
  };

export const createPageView =
  (pageName, url, type) => async (dispatch, getState) => {
    try {
      dispatch({
        type: CREATE_PAGE_VIEW_START,
      });
      let { access } = getState();

      if (isEmpty(access)) {
        access = JSON.parse(localStorage.getItem("token"));
      }

      const config = {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${access}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/users/page-views`,
        { page_name: pageName, page_url: url, type },
        config
      );

      dispatch({
        type: CREATE_PAGE_VIEW_SUCCESS,
        payload: data,
      });
    } catch (error) {
      // toastSuccess("There was a problem creating view");
      dispatch({
        type: CREATE_PAGE_VIEW_FAILURE,
        payload: error,
      });
    }
  };

export const fetchPageView = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: FETCH_PAGE_VIEW_START,
    });
    let { access } = getState();

    if (isEmpty(access)) {
      access = JSON.parse(localStorage.getItem("token"));
    }

    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    };
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/v1/users/page-views`,
      config
    );

    dispatch({
      type: FETCH_PAGE_VIEW_SUCCESS,
      payload: data,
    });
  } catch (error) {
    // toastSuccess("There was a problem creating view");
    dispatch({
      type: FETCH_PAGE_VIEW_FAILURE,
      payload: error,
    });
  }
};

// Async action creators
export const fetchPageFavorites = () => async (dispatch, getState) => {
  try {
    dispatch({ type: FETCH_PAGE_FAVORITES_START });
    let { access } = getState();
    if (isEmpty(access)) {
      access = JSON.parse(localStorage.getItem("token"));
    }

    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    };
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/v1/users/page-favorites`,
      config
    );
    dispatch({ type: FETCH_PAGE_FAVORITES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: FETCH_PAGE_FAVORITES_FAILURE, payload: error });
    console.error("Error fetching favorites:", error);
  }
};

export const addPageFavorite = (pageData) => async (dispatch, getState) => {
  try {
    let { access } = getState();
    if (isEmpty(access)) {
      access = JSON.parse(localStorage.getItem("token"));
    }

    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    };
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/v1/users/page-favorites`,
      pageData,
      config
    );
    dispatch({ type: FETCH_PAGE_FAVORITE_SUCCESS, payload: data });
  } catch (error) {
    console.error("Error adding favorite:", error);
    // Handle error
  }
};

export const removePageFavorite = (pageData) => async (dispatch, getState) => {
  try {
    let { access } = getState();
    if (isEmpty(access)) {
      access = JSON.parse(localStorage.getItem("token"));
    }

    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      data: pageData,
    };
    const data = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/api/v1/users/page-favorites`,
      config
    ); // Update with the correct API endpoint
    dispatch({ type: FETCH_PAGE_FAVORITE_SUCCESS, payload: data });
  } catch (error) {
    console.error("Error removing favorite:", error);
    // Handle error
  }
};

export const fetchPageFavorite = (pageName) => async (dispatch, getState) => {
  try {
    dispatch({ type: FETCH_PAGE_FAVORITE_START });
    let { access } = getState();
    if (isEmpty(access)) {
      access = JSON.parse(localStorage.getItem("token"));
    }

    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    };
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/v1/users/page-favorites?page_name=${pageName}`,
      config
    );
    dispatch({ type: FETCH_PAGE_FAVORITE_SUCCESS, payload: data });
  } catch (error) {
    console.error("Error fetching favorites:", error);
    dispatch({ type: FETCH_PAGE_FAVORITE_FAILURE, payload: error });
  }
};


export const saveEmailBody = (body, type) => async (dispatch, getState) => {
  try {
    dispatch({ type: EMAIL_BODY_REQUEST });
    let { access } = getState();
    if (isEmpty(access)) {
      access = JSON.parse(localStorage.getItem("token"));
    }

    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    };
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/v1/users/email_body`,
      { body: body, type: type },
      config
    );
    dispatch({ type: EMAIL_BODY_SUCCESS, payload: { body: data.body, type: type } });
    // toastSuccess("Email Body Saved Successfully")
  } catch (error) {
    dispatch({ type: EMAIL_BODY_FAIL, payload: error });
    // toastError("Unable to save email body")
  }
};

// New actions for paginated favorite projects
export const getFavoriteProjectsSummary = () => async (dispatch, getState) => {
  try {
    dispatch({ type: 'GET_FAVORITE_PROJECTS_SUMMARY_REQUEST' });
    let { access } = getState();
    if (isEmpty(access)) {
      access = JSON.parse(localStorage.getItem("token"));
    }

    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    };
    
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/v1/users/favorite-projects-summary`,
      config
    );
    
    dispatch({ 
      type: 'GET_FAVORITE_PROJECTS_SUMMARY_SUCCESS', 
      payload: data 
    });
    
  } catch (error) {
    dispatch({ 
      type: 'GET_FAVORITE_PROJECTS_SUMMARY_FAILURE', 
      payload: error.response?.data?.message || error.message 
    });
  }
};

export const getFavoriteProjectsPaginated = (column, page = 1, pageSize = 10, loadMore = false, searchTerm = '') => async (dispatch, getState) => {
  try {
    dispatch({ 
      type: 'GET_FAVORITE_PROJECTS_PAGINATED_REQUEST', 
      payload: { column, loadMore } 
    });
    
    let { access } = getState();
    if (isEmpty(access)) {
      access = JSON.parse(localStorage.getItem("token"));
    }

    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    };
    
    // Build URL with search parameter
    let url = `${process.env.REACT_APP_BASE_URL}/api/v1/users/favorite-projects?column=${column}&page=${page}&page_size=${pageSize}`;
    if (searchTerm && searchTerm.trim()) {
      url += `&search=${encodeURIComponent(searchTerm.trim())}`;
    }
    
    const { data } = await axios.get(url, config);
    
    if (loadMore) {
      dispatch({ 
        type: 'LOAD_MORE_FAVORITE_PROJECTS_SUCCESS', 
        payload: { column, data } 
      });
    } else {
      dispatch({ 
        type: 'GET_FAVORITE_PROJECTS_PAGINATED_SUCCESS', 
        payload: { column, data } 
      });
    }
    
  } catch (error) {
    dispatch({ 
      type: 'GET_FAVORITE_PROJECTS_PAGINATED_FAILURE', 
      payload: { column, error: error.response?.data?.message || error.message } 
    });
  }
};
